module.exports = __webpack_public_path__ + "img/hu6.c95e7921.jpg";